import AxiosIndicatorRunTimeLoader from "../../../component/AxiosIndicatorRunTimeLoader";
import React from "react";

class ProductDetail {
    static register = {
        PDT_VIEW_CART: {slug: 'PDT_VIEW_CART'},
        PDT_ADD_TO_CART: {slug: 'PDT_ADD_TO_CART', render: <AxiosIndicatorRunTimeLoader/>},
        PDT_ADD_TO_BOM: {slug: 'PDT_ADD_TO_BOM'},
        PDT_CLICK_TO_QUOTE:{slug:'PDT_CLICK_TO_QUOTE',render:<></>},
        PDTG_VIEW_CART: {slug: 'PDTG_VIEW_CART'},
        PDTG_ADD_TO_CART: {slug: 'PDTG_ADD_TO_CART', render: <AxiosIndicatorRunTimeLoader/>},
        PDTG_ADD_TO_BOM: {slug: 'PDTG_ADD_TO_BOM'},
        PDTG_CLICK_TO_QUOTE:{slug:'PDTG_CLICK_TO_QUOTE',render:<></>}
    };
    static register_external = {
        PDT_ADD_TO_BOM: {slug: 'PDT_ADD_TO_BOM', render: <></>},
    };
    static register_guest = {
        PDTG_VIEW_CART: {slug: 'PDTG_VIEW_CART'},
        PDTG_ADD_TO_CART: {slug: 'PDTG_ADD_TO_CART', render: <AxiosIndicatorRunTimeLoader/>},
        PDTG_ADD_TO_BOM: {slug: 'PDTG_ADD_TO_BOM'},
        PDTG_CLICK_TO_QUOTE:{slug:'PDTG_CLICK_TO_QUOTE',render:<></>}
    }
}

export default ProductDetail;